import { TourProvider as BaseTourProvider, useTour } from "@reactour/tour";
import IconButton from "../buttons/IconButton";
const TourProvider = ({ children, steps }) => {
  const disableBody = () => {
    document.body.style.overflow = "hidden";
    document.body.style.scrollbarGutter = "stable";
  };
  const enableBody = () => {
    document.body.style.overflow = "unset";
  };
  if (!steps) return children;

  return (
    <BaseTourProvider
      steps={steps}
      prevButton={({ setCurrentStep, currentStep }) => (
        <IconButton
          size="smaller"
          text
          color="secondary"
          handleClick={() => setCurrentStep(currentStep - 1)}
          icon="arrow-left"
          disabled={!(currentStep > 0)}
        ></IconButton>
      )}
      nextButton={({ setCurrentStep, currentStep, stepsLength }) => (
        <IconButton
          size="smaller"
          text
          color="secondary"
          handleClick={() => setCurrentStep(currentStep + 1)}
          icon="arrow-right"
          disabled={!(currentStep < stepsLength - 1)}
        ></IconButton>
      )}
      afterOpen={disableBody}
      beforeClose={enableBody}
      position="bottom"
      styles={{
        popover: (base) => ({
          ...base,
          "--reactour-accent": "var(--gradient-color)",
          borderRadius: "10px",
          padding: "2.5rem 1.5rem 1.5rem 1.5rem",
          fontFamily: "var(--font-family)",
          color: "var(--text-color)",
          background: "var(--card-color)",
          margin: "1rem",
          // maxWidth: "calc(100vw - 2rem)",
        }),
        maskArea: (base) => ({ ...base, rx: "10px", padding: "1rem" }),
        controls: (base) => ({
          ...base,
          marginTop: 20,
        }),
        close: (base) => ({
          ...base,
          top: "11px",
          right: "11px",
          color: "var(--text-color)",
          width: "13px",
        }),
        dot: (base, { current }) => {
          return {
            ...base,
            border: current ? "0px" : "1px solid var(--text-color)",
            height: "9px",
            width: "9px",
            margin: "0 3px",
            transition: "all 0.3s ease",
          };
        },
      }}
    >
      {children}
    </BaseTourProvider>
  );
};

export default TourProvider;
